import { render, staticRenderFns } from "./SafeForWorkStatusSettings.vue?vue&type=template&id=4d3693c8&scoped=true&"
import script from "./SafeForWorkStatusSettings.vue?vue&type=script&lang=ts&"
export * from "./SafeForWorkStatusSettings.vue?vue&type=script&lang=ts&"
import style0 from "./SafeForWorkStatusSettings.vue?vue&type=style&index=0&id=4d3693c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3693c8",
  null
  
)

export default component.exports